var map = {
	"./account.yml": 98908,
	"./advertisement.yml": 83452,
	"./backtesting.yml": 8185,
	"./badge-system.yml": 8881,
	"./chat.yml": 41021,
	"./common.yml": 34027,
	"./community.yml": 62514,
	"./connect-crypto-exchange.yml": 71841,
	"./connect-plaid.yml": 70203,
	"./dividend.yml": 87270,
	"./favorite.yml": 94960,
	"./footer.yml": 88424,
	"./header.yml": 43895,
	"./ieGuide.yml": 94970,
	"./investing-insights.yml": 62557,
	"./investingLog.yml": 16312,
	"./main.yml": 13050,
	"./mbti.yml": 2602,
	"./mobileAppGuider.yml": 84265,
	"./news-letter.yml": 33053,
	"./news.yml": 29098,
	"./notice.yml": 26478,
	"./onBoarding.yml": 82591,
	"./portfolio.yml": 99026,
	"./portfolios.yml": 39081,
	"./quote.yml": 59352,
	"./signin.yml": 50066,
	"./signup.yml": 62424,
	"./stock.yml": 71051,
	"./theRichGame.yml": 86169,
	"./user.yml": 10105,
	"src/i18n/languages/account.yml": 98908,
	"src/i18n/languages/advertisement.yml": 83452,
	"src/i18n/languages/backtesting.yml": 8185,
	"src/i18n/languages/badge-system.yml": 8881,
	"src/i18n/languages/chat.yml": 41021,
	"src/i18n/languages/common.yml": 34027,
	"src/i18n/languages/community.yml": 62514,
	"src/i18n/languages/connect-crypto-exchange.yml": 71841,
	"src/i18n/languages/connect-plaid.yml": 70203,
	"src/i18n/languages/dividend.yml": 87270,
	"src/i18n/languages/favorite.yml": 94960,
	"src/i18n/languages/footer.yml": 88424,
	"src/i18n/languages/header.yml": 43895,
	"src/i18n/languages/ieGuide.yml": 94970,
	"src/i18n/languages/investing-insights.yml": 62557,
	"src/i18n/languages/investingLog.yml": 16312,
	"src/i18n/languages/main.yml": 13050,
	"src/i18n/languages/mbti.yml": 2602,
	"src/i18n/languages/mobileAppGuider.yml": 84265,
	"src/i18n/languages/news-letter.yml": 33053,
	"src/i18n/languages/news.yml": 29098,
	"src/i18n/languages/notice.yml": 26478,
	"src/i18n/languages/onBoarding.yml": 82591,
	"src/i18n/languages/portfolio.yml": 99026,
	"src/i18n/languages/portfolios.yml": 39081,
	"src/i18n/languages/quote.yml": 59352,
	"src/i18n/languages/signin.yml": 50066,
	"src/i18n/languages/signup.yml": 62424,
	"src/i18n/languages/stock.yml": 71051,
	"src/i18n/languages/theRichGame.yml": 86169,
	"src/i18n/languages/user.yml": 10105
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 31197;